module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightIt.1d86051.eot";